import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconEditSmall2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="edit-small-2"><path d="M11.25 3.75H3.75V20.25H20.25V12.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 11.25V8.25L18.75 2.25L21.75 5.25L15.75 11.25H12.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconEditSmall2;
